// extracted by mini-css-extract-plugin
export default {"cls1":"StickyCtaFooter-cls1_FO7","cls2":"StickyCtaFooter-cls2_lIH StickyCtaFooter-cls1_FO7","hidden":"StickyCtaFooter-hidden_ONa"};